import React, { useEffect, useState } from "react";
import "./Inicio.css";
import { motion } from "framer-motion";
import { animationTwo } from "../Animations/animation";
import Galeria from "../Galeria/Galeria";
import Servicios from "../Servicios/Servicios";
import NavBar1 from "../NavBar/NavBar1";
import Contacto from "../Contacto/Contacto";
import Equipo from "../Equipo/Equipo";
import Direccion from "../Direccion/Direccion";
import Footer from "../Footer/Footer";
import Portada from "../Portada/Portada";
import GaleriaCarousel from "../GaleriaCarousel/GaleriaCarousel";
import QueOfrecemos from "../QueOfrecemos/QueOfrecemos";
import QuienesSomos from "../QuienesSomos/QuienesSomos";
import Helmet from "react-helmet";

export default function Inicio() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <motion.div
      initial="out"
      animate="in"
      exit="out"
      variants={animationTwo}
      style={{ padding: "0px", margin: "0px", backgroundColor: "#FFFAF4" }}
    >
      <Helmet>
        <meta charSet="utf-8" />
        <title>Estudio Eje - Home</title>
        <link rel="canonical" href="https://estudioeje.com.ar" />
      </Helmet>
      <NavBar1 />
      <Portada />
      <QuienesSomos />
      <Servicios />
      <Contacto />
      <Equipo />
      <div style={{ width: "100%", height: "10vh" }} />
      <QueOfrecemos />
      <Galeria />
      <GaleriaCarousel />
      <div style={{ width: "100%", height: "10vh" }} />
      <Direccion />
      <div style={{ width: "100%", height: "10vh" }} />
      <Footer />
    </motion.div>
  );
}
